// extracted by mini-css-extract-plugin
export default {"settings-page":"SettingsPage_settings-page__gh17h","input":"SettingsPage_input__bMSuF"};